import type { AmendmentRequest } from "@/views/amendmentRequest/amendmentRequest";
import { apiService } from "@modernary/mui/utils/api";
import { apiHosts } from "@/api/constants/apiHosts";
import type { NotifierConfig, NotifyOptionsError, NotifyOptionsSuccess } from "@modernary/mui/components/notifications";

const URL = "amendment-requests";
const ENTITY_NAME = "Amendment Request";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_ODR_API_BASE_URL,
};
const api = apiService<AmendmentRequest>(apiHosts.ODR, axiosParams);

const createAmendmentRequest = (amendmentRequest: AmendmentRequest, config: NotifierConfig = {}) => {
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.title = "Amendment Request Submitted";
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.created = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  return api.post(URL, amendmentRequest, {
    successNotifCb,
    errorNotifCb,
  });
};

export { createAmendmentRequest };
